<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Move to Different Sleeve</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <ng-container>
    <nf-table-layout
      *nfLoader="isLoadingSubSleeveAccounts || formSubmitting"
      class="table"
      hideTitle
      hideClearAll
      hideSearch
      [gridOptions]="gridOptions"
      [data]="subAccounts"
    ></nf-table-layout>
  </ng-container>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button nf-button="save" (click)="save()" [disabled]="disableSave"></button>
  </div>
</div>
